export default __webpack_public_path__ + "static/media/Group 980.4a44468e.png";